<template>
  <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <div class="vertFlexStretch mainimagealldiv">
                <div class="imagediv" >
                    <img alt="selfie image"  :src="capturedImageURL" class="image" v-if="capturedImageURL!=null"/>
                    <div class="editdiv">
                        <smallbutton toplabel="Edit" buttonclass="editbutton" @click="$refs.imgedit.openModal()" v-if="havePic"/>
                    </div>
                </div>

                <div >
                    <imagecapture ref="imgcapture" :allowCapture="allowCapture" :fileAccept="fileAccept" buttonClass="pbutton" :allowFileSelect="allowFileSelect" :allowFileSelectIfNoCapture='allowFileSelectIfNoCapture' @gotimage="gotImage"  :showImage='showImage'  />
                    
                </div>

                <label class="guideline">For optimal speed and viewing, please use the following guidelines:</label>

                <label class="guideline leftmargin">     * eCommerce: Keep images under 200 KB. Use WebP or compressed JPG/PNG.</label>
                <label class="guideline leftmargin">     * POS: Keep images under 200 KB.</label>
                <label class="guideline leftmargin">     * Mobile POS: Keep images under 100 KB. For uniform image size, stay to 360px X 360px.</label>

                <!-- <label class="responsemessage" v-if="message1!=null">{{ message1 }}</label>
                <br>
                <label class="responsemessage" v-if="message2!=null">{{ message2 }}</label> -->
                <div >
                    <smallbutton toplabel="Save" @click="savepic()" buttonclass="button buttonsave"/>
                    <smallbutton toplabel="Cancel" @click="$refs.mymodal.closeModal()" buttonclass="button buttoncancel"/>
                </div>
            </div>
            <imageeditor ref="imgedit" :img="capturedImageURL" @save="saveedits"/>
            
            <div v-if="photoRequirements!=null">
              <hr>
              <label class="titlelabel">Picture Requirements</label>
              <br>
              <label v-html="safePhotoRequirements" class="photoreq" />
          </div> 
        </template>
      </actionmodal>
</template>

<script>
import actionmodal from '../controls/actionmodal.vue'
import smallbutton from './button.vue'
import imagecapture from '../controls/ImageCapture.vue'
import imageeditor from '../controls/ImageEditor.vue'
import datamethods from '../../services/datamethods'
import DOMPurify from 'dompurify'
export default {
    name:'imageall',
    mixins:[datamethods],
    components:{
        actionmodal,
        smallbutton,
        imagecapture,
        imageeditor
    },
    props: {
        allowCrop:{
            type:Boolean,
            default:true
        },
        allowRotate:{
            type:Boolean,
            default:true
        },
        allowFileSelect:{
          type:Boolean,
          default:false
        },
        allowFileSelectIfNoCapture:{
          type:Boolean,
          default:false
        },
        allowCapture:{
            type:Boolean,
            default:true
        },
        useRearCamera:{
            type:Boolean,
            default:false
        },
        selectedImageClass:{
          type:String,
          default:'selectedImage'
        },
        buttonClass:{
          type:String,
          default:'captureButton'
        },
        buttonLabelClass:{
          type:String,
          default:'buttonlabel'
        },
        pleaseWaitMessage:{
          type:String,
          default:'Please Wait...'
        },
        fileSelectText:{
          type:String,
          default:'Upload File'
        },
        captureText:{
          type:String,
          default:'Take Picture'
        },
        webCamCaptureText:{
          type:String,
          default:'Capture Photo'
        },
        showDeviceInfo:{
          type:Boolean,
          default:false
        },
        showImage:{
          type:Boolean,
          default:true
        },
        fileAccept:{
          type:String,
          default:'image/*'
        },
        resizeImages:{
          type:Boolean,
          default:true
        },
        referenceID:{
            type:Number,
            default:-1
        },
        defaultImage:{
            type:String,
            default:'@/assets/newproduct.jpg'
        }
    },
    data() {
		return {
            pleaseWait:false,
            capturedImage:null,
            capturedImageURL:null,
            havePic:false,
            photoRequirements:null,
            message1:null,
            message2:null
		};
	},
    computed:{
        // Server-sourced HTML (response.StringResponse) — sanitize before v-html to block stored XSS.
        safePhotoRequirements(){
            return this.photoRequirements==null ? null : DOMPurify.sanitize(this.photoRequirements)
        }
    },
    methods: {
        
        openModal(){
            if(this.defaultImage==''){this.capturedImageURL=null}
            else{
                this.capturedImageURL=require('@/assets/newproduct.jpg')
            }
            
            this.$refs.mymodal.openModal()
        },
        gotImage(file,url,sizeKB,imageheight, imagewidth){
            this.message1=null
            this.message2=null
            console.log('image size ' + sizeKB)
            console.log('image height and width ' + imageheight + ' ' + imagewidth)
            this.capturedImage=file
            this.capturedImageURL=url
            this.havePic=true
            if (sizeKB>20){this.message1='Your file is too big to load quickly on your POS applications.  Please choose a file smaller than 20 KB'}
            if (imageheight!=imagewidth){
                this.message2="The height and width of your file are different. Please choose a square file."
            }
        },

		saveedits(file, url){
            this.capturedImage=file
            this.capturedImageURL=url
        },
        savepic(){
            this.$emit('saveimg',this.capturedImage, this.capturedImageURL, this.referenceID)
            this.$refs.mymodal.closeModal();
        },
        async getPhotoReq(){
            let req = {
                locationId:-1
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'photoreq')

            //handle response
            if(response.Successful){
                this.photoRequirements = response.StringResponse
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
	},
    mounted(){
        //this.getPhotoReq()
    }
}
</script>

<style>

.pbutton{
    background-color:var(--button-color);
    color:var(--light-text-color);
    border: none;
    padding-top:0px;
    padding-bottom:20px;
    min-width:120px;
    height:25px;
    
    font-size: medium;
    margin:10px;

    text-decoration: none;

}

@media screen and (min-width: 812px) {
    .image{
      margin:10px;
      max-width:90%; 
      height:auto;
    }
}
/* phone */
@media screen and (max-width: 812px) {
   .image{
      margin:10px;
      width:auto; 
      max-height: 250px;
    }
    
}
.mainimagealldiv{
    min-height: 350px;
}
.guideline{
    text-align: left;
    font-size:smaller;
}
.leftmargin{
    margin-left:20px;
}
</style>